'use strict';
let sheetScript = {
    data() {
        return {
            transportShow: false,
            oldTransportShow: false,
            selectTemplateShow: false,
            transportList: [],
            sheetList: [],
            transValidateRules: {
                /*  SHIP_TYPE: [{required: true, message: '请选择运输类型', trigger: 'blur'}],
                  SHIP_CODE: [{required: true, message: '请填写提单号或车板号', trigger: 'blur'}],
                  SHIP_NAME: [{required: true, message: '请填写运输班次', trigger: 'blur'}],*/
                SHIP_DETAIL: [{required: true, message: this.$t('pleaseSelectTheShippingBox'), trigger: 'blur'}],
            },
            transForm: {
                SHIP_DETAIL: [],
            },
            boxOptions: [],
            shipNameList: [],
            transParamsData: {
                "SYS_TYPE": "20011003",
                "TARGET_CATE": "20021022",
                "TARGET_TYPE": "20071007",
                "TARGET_ID": "",
                "GUID_CODE": ""
            },
            oldTransParamsData: {
                "SYS_TYPE": "20011003",
                "TARGET_CATE": "20021020",
                "TARGET_TYPE": "20071007",
                "TARGET_ID": "",
                "GUID_CODE": ""
            },
            transTemplateList: [],
            nodeDisabled:false,
            boxShowModel: false,
            boxList: [],
            editBoxModel: false,
            wharfSql: 'SELECT A.*,B.CITY_NAME,B.CITY_NAME_ENG,B.CITY_NAME_RUS,C.DIC_NAME,C.DIC_NAME_ENG,C.DIC_NAME_RUS FROM GM_STATION_WHARF A LEFT JOIN GM_CITY B ON A.CITY_ID=B.CITY_ID LEFT JOIN GM_SYS_DIC C ON A.SW_TYPE = C.DIC_CODE WHERE A.STATUS = 1',
        }
    },
    computed: {
        transportBox() {
            let boxList = [];
            this.transportList.forEach(item => {
                boxList.push(...item.BOX_CODE_ARR)
            })
            return boxList;
        },
    },
    methods: {
        addNodeManually() {
            this.nodeDisabled = false
            this.transportShow = true
        },
        editTrans(record, masterId) {
            this.nodeDisabled = false
            this.$h5Api({
                type: '4073',
                data: [{
                    "SHIP_ID": record.SHIP_ID,
                    "XC_MASTER_ID": masterId,
                    "PARENT_SHIP_ID": record.PARENT_SHIP_ID
                }],
            }).then(({data}) => {
                data.LIST.forEach(item => {
                    item.label = item.BOX_CODE;
                    item.value = item.BOX_CODE;
                })
                this.boxOptions = data.LIST
                this.transForm = {...record}
                this.transForm.SHIP_TYPE = this.transForm.SHIP_TYPE.toString()
                let list = []
                data.LIST.forEach(item => {
                    if(item.IS_CHECK === 1) {
                        list.push(item.BOX_CODE)
                    }
                })
                this.$set(this.transForm, 'SHIP_DETAIL', list);
            })
            this.transportShow = true
        },
        editBox(record,masterId) {
            this.$h5Api({
                type: '4073',
                data: [{
                    "SHIP_ID": record.SHIP_ID,
                    "XC_MASTER_ID": masterId,
                    "PARENT_SHIP_ID": record.PARENT_SHIP_ID
                }],
            }).then(({data}) => {
                data.LIST.forEach(item => {
                    item.label = item.BOX_CODE;
                    item.value = item.BOX_CODE;
                })
                this.boxOptions = data.LIST
                this.transForm = {...record}
                this.transForm.SHIP_TYPE = this.transForm.SHIP_TYPE.toString()
                let list = []
                data.LIST.forEach(item => {
                    if(item.IS_CHECK === 1) {
                        list.push(item.BOX_CODE)
                    }
                })
                this.$set(this.transForm, 'SHIP_DETAIL', list);
            })
            this.editBoxModel = true
        },
        checkAllTrans(e) {
            let SHIP_DETAIL = [];
            this.boxOptions.forEach(item => {
                SHIP_DETAIL.push(item.BOX_CODE);
            })
            this.$set(this.transForm, 'SHIP_DETAIL', e.target.checked ? SHIP_DETAIL : []);
        },
        oldCheckAllTrans(e) {
            let SHIP_DETAIL = [];
            this.boxOptions.forEach(item => {
                if (!item.disabled) {
                    SHIP_DETAIL.push(`${item.BOX_ID},${item.FLOW_ID}`);
                }
            })
            this.$set(this.transForm, 'SHIP_DETAIL', e.target.checked ? SHIP_DETAIL : []);
        },
        oldAddTrans(OPER_TYPE = 0, record = {}) {
            let transData = Object.assign({}, record);
            if(OPER_TYPE === 0 && this.xbOrderMaster.SHIP_NN){
              transData.SHIP_NAME =  this.xbOrderMaster.SHIP_NN;
            }
            this.$h5Api({
                type: '4029',
                data: [{
                    "MASTER_ID": this.orderForm.MASTER_ID,
                }],
            }).then(({data}) => {
                let boxOptions = [];
                let SHIP_DETAIL = [];
                data.OT_SHEET_SHIP.forEach(item => {
                    item.label = item.BOX_CODE;
                    item.value = `${item.BOX_ID},${item.FLOW_ID}`;
                    if (!(OPER_TYPE === 1 && item.SHIP_CODE === record.SHIP_CODE)) {
                        item.disabled = item.SHIP_STATUS ? true : false;
                    } else {
                        SHIP_DETAIL.push(`${item.BOX_ID},${item.FLOW_ID}`)
                    }
                    transData.SHIP_TYPE = String(transData.SHIP_TYPE || this.orderForm?.TRANS_WAY_CODE || '10000153');
                    boxOptions.push(item);
                    transData.SHIP_DETAIL = SHIP_DETAIL;
                })
                transData.OPER_TYPE = OPER_TYPE;
                this.transForm = transData;
                this.boxOptions = boxOptions;
                this.oldTransportShow = true;
            })
        },
        addTrans() {
            this.$refs.transTree.open();
        },
        removeTransport(data) {
            let SHIP_DETAIL = [];
            data.BOX_CODE_ARR.forEach(item => {
                SHIP_DETAIL.push({"FLOW_ID": item.FLOW_ID, "BOX_ID": item.BOX_ID})
            })
            this.$confirm({
                content: "是否确认删除?",
                onOk: () => {
                    if (this.loading) {
                        this.loading = false;
                        this.$h5Api({
                            type: '4030',
                            data: [{
                                "OPER_TYPE": 2,
                                "SHIP_TYPE": data.SHIP_TYPE,
                                "SHIP_CODE": data.SHIP_CODE,
                                "SHIP_NAME": data.SHIP_NAME,
                                "SHIP_DETAIL": SHIP_DETAIL
                            }],
                        }).then(({data}) => {
                            this.$message.info(this.$t('operateSuccessfully'))
                            this.transportShow = false;
                            this.getOrderDetail(this.$route.query.MASTER_ID);
                        }).finally(() => {
                            this.loading = true;
                        })
                    }
                },
                onCancel() {
                },
            });

        },
        closeTrans() {
            this.transForm = {
                SHIP_DETAIL: [],
            };
            this.transportShow = false;
            this.oldTransportShow = false;
        },
        oldSaveTransport() {
            let SHIP_DETAIL = [];
            let file
            this.$refs.transForm.validate(val => {
                if (val) {
                    if (this.transForm.GUID_CODES && this.transForm.GUID_CODES instanceof Array) {
                        file = this.transForm.GUID_CODES.map(item => {
                            if (typeof item === 'object') {
                                return item.GUID_CODE;
                            } else {
                                return item;
                            }
                        }).join(',');
                    } else {
                        file = this.transForm.GUID_CODES;
                    }
                    this.transForm.SHIP_DETAIL.forEach(item => {
                        SHIP_DETAIL.push({
                            BOX_ID: item.split(',')[0],
                            FLOW_ID: item.split(',')[1],
                            GUID_CODES: file
                        })
                    })
                    let condition = {
                        OPER_TYPE: this.transForm.OPER_TYPE,
                        SHIP_TYPE: this.transForm.SHIP_TYPE,
                        SHIP_CODE: this.transForm.SHIP_CODE,
                        SHIP_NAME: this.transForm.SHIP_NAME,
                        SHIP_DETAIL: SHIP_DETAIL,
                    };
                    if (this.loading) {
                        this.loading = false;
                        this.$h5Api({
                            type: '4030',
                            data: [condition],
                        }).then(({data}) => {
                            this.$message.info(this.$t('operateSuccessfully'))
                            this.transForm = {};
                            this.oldTransportShow = false;
                            this.getOrderDetail(this.$route.query.MASTER_ID);
                        }).finally(() => {
                            this.loading = true;
                        })
                    }
                }
            })
        },
        getShipNameList(value) {
            if (!value) return true
            let condition = [{
                "GET_HEAD": [{
                    "GET_METHOD": 1,
                    "GET_TABLE": "GM_INPUT_PROMPT",
                    "BEGIN_ROW_NO": this.current,
                    "GET_ROW_CNT": 10,
                    "SORT_FIELD": "UPDATE_DATE"
                }],
                "GET_FILTER": [
                    {
                        "FILTER_FIELD": "PROMPT_CONTENT",
                        "FILTER_TYPE": 4,
                        "FILTER_VALUE1": value,
                        "FILTER_VALUE2": '',
                    },
                    {
                        "FILTER_FIELD": "INPUT_TYPE",
                        "FILTER_TYPE": "1",
                        "FILTER_VALUE1": 0,
                        "FILTER_VALUE2": '',
                    },
                    {
                        "FILTER_FIELD": "STATUS",
                        "FILTER_TYPE": "1",
                        "FILTER_VALUE1": 1,
                        "FILTER_VALUE2": '',
                    }
                ]
            }]
            this.$h5Api({
                type: '1001',
                data: condition,
                showMessage: false,
                loading: false,
            }).then(data => {
                let list = []
                data.data['DATA_LIST'].forEach(item => {
                    list.push(item.PROMPT_CONTENT)
                })
                this.shipNameList = list
                this.total = list.length
            })
        },
        getShipName(value) {
            this.transForm.SHIP_NAME = value
        },
        transFinished(data) {
            this.$set(this.transForm, 'GUID_CODES', data?.FILE_LIST?.[0]?.['GUID_CODE']);
            this.$refs.transForm.validateField('GUID_CODES');
        },
        downTransFile(data) {
            let condition = {
                "SYS_TYPE": "20011003",
                "TARGET_CATE": "20021020",
                "TARGET_TYPE": "20071007",
                "TARGET_ID": data.FLOW_ID
            }
            this.$h5Api({
                type: '2021',
                data: [condition],
            }).then(({data}) => {
                this.$Dolphin.download(data?.FILE_LIST?.[0]?.FILE_NAME, this.$Dolphin.path.filePath + data?.FILE_LIST?.[0]?.FILE_NAME)
            })
        },
        openSelectTemplate(CITY_ID, D_CITY_ID) {
            this.$h5Api({
                type: '4066',
                data: [{
                    CITY_ID: CITY_ID,
                    D_CITY_ID: D_CITY_ID,
                    "PAGE_SIZE": 999,
                    "PAGE_INDEX": 1
                }],
            }).then(({data}) => {
                this.transTemplateList = data.TA_LIST
            })
            this.selectTemplateShow = true
        },
        confirmTemplate(MASTER_ID, XC_MASTER_ID, XC_SHEET_CODE) {
            this.$h5Api({
                type: '4070',
                data: [{
                    "MASTER_ID": MASTER_ID,
                    "XC_MASTER_ID": XC_MASTER_ID,
                    "XC_SHEET_CODE": XC_SHEET_CODE
                }],
            }).then(({data}) => {
                this.selectTemplateShow = false
                this.getOrderDetail(this.$route.query.MASTER_ID);
            })
        },
        delNode(obj) {
            this.$h5Api({
                type: '4072',
                data: [{
                    "SHIP_ID": obj.SHIP_ID
                }],
            }).then(({data}) => {
                this.$message.info(this.$t('operateSuccessfully'))
                this.getOrderDetail(this.$route.query.MASTER_ID);
            })
        },
        addFollowUp(record,masterId) {
            this.nodeDisabled = true
            this.$h5Api({
                type: '4073',
                data: [{
                    "SHIP_ID": '',
                    "XC_MASTER_ID": masterId,
                    "PARENT_SHIP_ID": record.SHIP_ID
                }],
            }).then(({data}) => {
                data.LIST.forEach(item => {
                    item.label = item.BOX_CODE;
                    item.value = item.BOX_CODE;
                })
                this.boxOptions = data.LIST
                this.transForm = {
                    NATION: record.D_NATION,
                    CITY_ID: record.D_CITY_ID,
                    PARENT_SHIP_ID: record.SHIP_ID,
                    SW_ID: record.D_SW_ID,
                    D_CITY_ID: ''
                }
                let list = []
                data.LIST.forEach(item => {
                    if(item.IS_CHECK === 1) {
                        list.push(item.BOX_CODE)
                    }
                })
                this.$set(this.transForm, 'SHIP_DETAIL', list);
            })
            this.transportShow = true
        },
        openBoxModel(boxList) {
            this.boxShowModel = true,
            this.boxList = boxList
        }
    },
    created() {
    }
};

export default sheetScript;